// assets
import { UserPermissions } from '@mrp-system/common';
import { IconDashboard } from '@tabler/icons';
import { SidebarMenu } from 'utils/types';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard: SidebarMenu = {
  id: 'dashboard',
  title: 'Painel',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Painel',
      type: 'item',
      url: '/dashboard',
      icon: IconDashboard,
      breadcrumbs: false,
      caption: 'Principal',
      permissionsRequired: [UserPermissions.GET_COMPANY_DASHBOARD_DATA],
    },
  ],
};

export default dashboard;
